import state from './moduleTableState.js'
import mutations from './moduleTableMutations.js'
import actions from './moduleTableActions.js'
import getters from './moduleTableGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
